import React, { useState, useCallback, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as R from 'ramda';
import applySelectors from '../../utils/applySelectors';
import useLoading from '../../hooks/withLoading';
import Head from '../../components/Head';
import { List } from '../../components/Webinars';
import actions from '../../store/webinars/actions';
import selectors from '../../store/webinars/selectors';
import Pagination from '../../components/Pagination';
import DeleteModal from '../../components/DeleteModal';

const WebinarsListContainer = ({
  history,
  getWebinars,
  deleteWebinar,
  list,
  pagination,
  nextSequencePage,
  prevSequencePage,
}) => {
  const getWebinarsPagination = useCallback(
    () => getWebinars({ cursor: pagination.currentCursor }),
    [getWebinars, pagination.currentCursor]
  );
  const [loading] = useLoading(getWebinarsPagination);
  const [deleteId, setDeleteId] = useState();
  const [isDeleting, setIsDeleting] = useState();

  const onAddHandler = () => {
    history.push('/webinars/add');
  };

  const onEditHandler = (id) => {
    history.push(`/webinars/edit/${id}`);
  };

  const onDeleteHandler = async () => {
    try {
      setIsDeleting(true);
      await deleteWebinar(deleteId);
    } finally {
      setDeleteId(false);
      setIsDeleting(false);
    }
  };

  const openDeleteModal = id => {
    setDeleteId(id);
  };
  const closeDeleteModal = () => {
    if (isDeleting) {
      return;
    }

    setDeleteId(false);
  };

  return (
    <>
      <Head title='Webinars' onAdd={onAddHandler} />
      <List
        loading={loading}
        list={list}
        onEdit={onEditHandler}
        onDelete={openDeleteModal}
      />
      <div className='text-center'>
        <Pagination
          page={pagination.current_page}
          total={pagination.total}
          isProcess={loading}
          next={pagination.has_more}
          prev={pagination.current_page}
          onNext={nextSequencePage}
          onPrev={prevSequencePage}
        />
      </div>
      <DeleteModal
        title='Delete webinar'
        show={deleteId}
        onHide={closeDeleteModal}
        onDelete={onDeleteHandler}
        isProcess={isDeleting}
      />
    </>
  );
};

const mapStateToProps = applySelectors({
  list: selectors.selectSequences,
  pagination: selectors.selectPagination,
});

export default R.pipe(
  connect(mapStateToProps, actions),
  withRouter,
)(WebinarsListContainer);;
